import React from 'react'

import { Box, Typography } from '@/elements'
import { Color } from '@/utils'

export const TableNoData = ({ text = '' }) => (
    <Box margin="0 5px">
        <Typography variant="body2" color={Color.textSecondary}>
            {text}
        </Typography>
    </Box>
)